import { EPopupActionType, EPopupType } from './types';
import { actionGenerator } from '../../redux/actionGenerator';

export const openPopup = actionGenerator<EPopupActionType.Open, EPopupType>(EPopupActionType.Open);
export const closePopup = actionGenerator<EPopupActionType.Close>(EPopupActionType.Close);
